// eslint-disable-next-line import/prefer-default-export
export const cjwt = {
  path: '/cjwt',
  name: 'cjwt',
  redirect: '/cjwt/tywt',
  component: () => import('../views/cjwt/cjwt.vue'),
  children: [
    {
      path: '/cjwt/tywt',
      name: 'cjwt_tywt',
      component: () => import('../views/cjwt/tywt.vue'),
    },
    {
      path: '/cjwt/gncz',
      name: 'cjwt_gncz',
      component: () => import('../views/cjwt/gncz.vue'),
    },
    {
      path: '/cjwt/qtwt',
      name: 'cjwt_qtwt',
      component: () => import('../views/cjwt/qtwt.vue'),
    },
  ],
};
